<template>
	<!-- 监理周报 -->
	<div class="mod-config">
		<div ref="basic" style="height:20px;margin-top:-20px"></div>
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :inline="true" class="border-form">
			<el-card style="margin-top: 20px; height: 100%;">
				<el-row>
					<el-input v-model="dataForm.weeklyName" placeholder="请输入" class="monthly-input" v-if="basicVisible"
						style="width: 150px;" />
					<span v-if="!basicVisible" style="font-weight: bold;font-size:16px">
						{{ dataForm.weeklyName }}
					</span>
				</el-row>
				<el-row style="text-align:center;font-weight:bold;font-size: 17px;">
					监理周报
				</el-row>
				<el-row style="text-align:center;font-weight:bold;font-size: 17px;margin-bottom: 5px;">
					<div>{{ dataForm.showWeeklyDate }}</div>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-row class="set_border">
							<el-col :span="12" class="col-set_border">
								<el-form-item label-width="120px" label="项目名称" class="item">
									<span class="set_span">
										{{ dataForm.projectInfo.projectName }}
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label-width="120px" label="数量" class="item">
									<el-input class="sp-input" v-model="dataForm.projectNum" placeholder="请输入"
										v-if="basicVisible">
									</el-input>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.projectNum }}
									</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="24">
								<el-form-item label-width="120px" label="委托方" class="item">
									<span class="set_span">
										{{ dataForm.projectInfo.projectEntrust }}
									</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="12" class="col-set_border">
								<el-form-item label-width="120px" label="工程承包方" class="item">
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.projectInfo.contractCompany }}
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label-width="120px" label="工程编号" class="item">
									<el-input class="sp-input" v-model="dataForm.projectSubjectNo" placeholder="请输入"
										v-if="basicVisible">
									</el-input>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.projectSubjectNo }}
									</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="12" class="col-set_border">
								<el-form-item label-width="120px" label="报告人" class="item">
									<el-input class="sp-input" v-model="dataForm.reportMan" placeholder="请输入"
										v-if="basicVisible">
									</el-input>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.reportMan }}
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label-width="120px" label="时间" class="item">
									<!-- {{dataForm.refirmTime}} -->
									<el-date-picker v-model="dataForm.reportTime" type="date" value-format="yyyy-MM-dd"
										placeholder="选择日期" class="sp-input" v-if="basicVisible">
									</el-date-picker>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.reportTime }}
									</span>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row class="set_border">
							<el-col :span="12" class="col-set_border">
								<el-form-item label-width="120px" label="项目总监" class="item">
									<el-input class="sp-input" v-model="dataForm.projectDirector" placeholder="请输入"
										v-if="basicVisible">
									</el-input>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.projectDirector }}
									</span>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label-width="120px" label="时间" class="item">
									<!-- {{dataForm.refirmTime}} -->
									<el-date-picker v-model="dataForm.projectDirectorTime" type="date"
										value-format="yyyy-MM-dd" placeholder="选择日期" class="sp-input"
										v-if="basicVisible">
									</el-date-picker>
									<span class="set_span" v-if="!basicVisible">
										{{ dataForm.projectDirectorTime }}
									</span>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
					<!-- <el-col :span="2">
						<i class="el-icon-edit-outline" @click="updateBasicHandle()" v-if="!basicVisible">
							<el-button type="text" size="small" style="font-size: 13px;"
								:disabled="updateFlg || addFlg">修改</el-button>
						</i>
						<i class="el-icon-finished" @click="saveBasicHandle()" v-if="basicVisible">
							<el-button type="text" size="small" @click="saveBasicHandle()"
								:disabled="updateFlg || addFlg">保存</el-button>
						</i>
						<i class="el-icon-takeaway-box" v-if="basicVisible" :disabled="updateFlg || addFlg"
							@click="cancelSaveBasicHandle()">
							<span style="font-size: 12px;margin-left:2px;">取消</span>
						</i>
					</el-col> -->
				</el-row>
				<el-row class="set_border">
					<el-col :span="24" style="text-align: right;padding: 4px 2px 4px 0;">
						<el-button class="btn" type="primary" size="small" @click="updateBasicHandle()"
							v-if="!basicVisible">修改</el-button>
						<el-button class="btn" type="primary" size="small" @click="saveBasicHandle()"
							v-if="basicVisible">保存</el-button>
						<el-button class="rebtn" size="small" @click="cancelSaveBasicHandle()"
							v-if="basicVisible">取消</el-button>
					</el-col>
				</el-row>
				<div ref="overview"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">1. 概述</div>
				<el-row>
					<el-row>
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.1 重要事项描述</span>
						</el-form-item>
					</el-row>
					<el-row>
						<draggable v-model="dataForm.projectDesc" @start="onDragStart('010100')" @update="onDragEnd">
							<el-row :span="24" v-for="(prodec, index) in dataForm.projectDesc" :key="'prodec' + index">
								<el-tooltip placement="top" effect="light"
									:content="(prodec.updUserName || '') + ' ' + prodec.updDate" :enterable="false">
									<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(prodec)">
											<el-col :span="22" class="desc_span">
												{{ prodec.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="prodec.showButton == 1"
													@click="addOrUpdateSituation(prodec.recNo, '010100')">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn" v-if="prodec.showButton == 1"
													@click="deleteWeeklyReportFile(prodec.recNo, '010100')">
													×
												</el-button>
											</el-col>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in prodec.photoRecords"
												:key="'prodecPhoto' + index1" style="margin-top: 20px;"
												v-if="prodec.photoRecords != undefined && prodec.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit="contain"></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '010100')">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('010100')">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspanDetail">1.2 本周工程质量状况</span>
							<el-radio-group v-model="dataForm.qualitySituation" @change="saveBasicHandle()"
								:disabled="updateFlg || addFlg || basicVisible">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">不正常</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:85px">1.3 本周发出监理联系单 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.contactNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:85px">1.4 本周发出监理通知单 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.noticeNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:85px">1.5 本周发出不一致报告 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.disAccordNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:124px">1.6 本周文件审查 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.fileCheckNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.7 本周检验项目</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.testItemRecords" header-align="center" border
							style="width: 100%; font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }"
							:span-method="objectTestRecordMethod">
							<el-table-column prop="subjectNo" label="船号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专业" width="120" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionCount" label="接受" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionWhereCount" label="有条件接受 " align="center">
							</el-table-column>
							<el-table-column prop="recheckAfterCorrectionCount" label="修正后复检 " align="center">
							</el-table-column>
							<el-table-column prop="testConclusionRefuseCount" label="不接受" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionTotalCount" label="总计 " align="center">
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.8 巡检整改项目</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.patrolItemRecords" header-align="center" border
							style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }"
							:span-method="objectInspectionMethod">
							<el-table-column prop="subjectNo" label="船号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专业" width="120" align="center">
							</el-table-column>
							<el-table-column prop="applyNum" label="本周内提出整改数" align="center">
							</el-table-column>
							<el-table-column prop="alreadyModifyNum" label="截至本周已整改数" align="center">
							</el-table-column>
							<el-table-column prop="notFinishNum" label="截止本周未整改数 " align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<div ref="progress"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">2. 施工进度情况</div>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.1 分段进度表</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :data="dataForm.sectionalItemRecords" header-align="center"
							border style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="工程编号" align="center">
							</el-table-column>
							<el-table-column prop="totalNum" label="分段总数" align="center">
							</el-table-column>
							<el-table-column prop="upNum" label="上胎架数量" align="center">
							</el-table-column>
							<el-table-column prop="checkNum" label="验收完成数" align="center">
							</el-table-column>
							<el-table-column prop="paintingNum" label="涂装完工数" align="center">
							</el-table-column>
							<el-table-column prop="upShipNum" label="上船台总装数" align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.2 系泊试验进度表</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 10px;">
						<el-table class="dataListTable" :data="dataForm.mooringTestItemRecords" header-align="center"
							border style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="工程编号" align="center">
							</el-table-column>
							<el-table-column prop="testItemNum" label="系泊试验项目总数" align="center">
							</el-table-column>
							<el-table-column prop="testFinishItemNum" label="系泊试验完成总数" align="center">
							</el-table-column>
							<el-table-column prop="shipFinishItemNum" label="船体系泊试验项目完成数" align="center">
							</el-table-column>
							<el-table-column prop="turbineFinishItemNum" label="轮机系泊试验项目完成数" align="center">
							</el-table-column>
							<el-table-column prop="electricalFinishItemNum" label="电气系泊试验项目完成数" align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-row>
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.3 详细进度情况</span>
						</el-form-item>
					</el-row>
					<el-row v-for="(conProgress, index) in dataForm.constructionProgress" :key="'conProgress' + index">
						<el-row class="set_sub" v-if="showSubjectName">{{ conProgress.projectNo }}</el-row>
						<el-row v-for="(conPro, index1) in conProgress.conProgressList" :key="'conPro' + index1">
							<el-row class="set_major">
								<el-col :span="24" class="conp">{{ conPro.majorName }}：</el-col>
							</el-row>
							<draggable v-model="conPro.descProgressList" @start="onDragStart('020300', index, index1)"
								@update="onDragEnd">
								<el-row v-for="(progress, index2) in conPro.descProgressList" :key="'pro' + index2"
									style="margin-left: 90px;">
									<el-tooltip placement="top" effect="light"
										:content="(progress.updUserName || '') + ' ' + progress.updDate"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
											<el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col>
											<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(progress)">
												<el-col :span="22" class="desc_span">
													{{ progress.descContent }}
												</el-col>
												<!-- 占位 -->
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<!-- <el-col :span="2"> -->
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="progress.showButton == 1"
													@click="addOrUpdateSituation(progress.recNo, '020300', conProgress.subjectNo, conPro.major)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn" v-if="progress.showButton == 1"
													@click="deleteWeeklyReportFile(progress.recNo, '020300')">
													×
												</el-button>
												<!-- </el-col> -->
											</el-col>
											<!-- <el-col :span="24">
												<div v-for="(photo, index1) in progress.photoRecords"
													:key="'progressPhoto' + index1" style="margin-top: 20px;">
													<el-col :span="24" style="margin-left:20px;">
														<el-image style="min-height: 220px;"
															:src="photo.compressedPathUri" fit="contain"></el-image>
													</el-col>
												</div>
											</el-col> -->
											<el-col :span="23" style="width:90%;margin-left:170px">
												<div v-for="(photo, index1) in progress.photoRecords"
													:key="'progressPhoto' + index1" style="margin-top: 20px;"
													v-if="progress.photoRecords != undefined && progress.photoRecords.length > 0">
													<el-col :span="9">
														<div style="margin:20px 20px 20px 20px ">
															<el-image style="height: 250px;"
																:src="photo.compressedPathUri" fit="contain"></el-image>
														</div>
													</el-col>
												</div>
											</el-col>
										</el-col>
									</el-tooltip>
								</el-row>
							</draggable>
							<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
								<el-tooltip content="添加描述" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="addOrUpdateSituation('', '020300', conProgress.subjectNo, conPro.major)">
										<i class="el-icon-plus btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="选择描述内容" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="chooseProgressKindHandle('020300', conProgress.subjectNo, conPro.major)">
										<i class="el-icon-search btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="上期数据参考" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="lastRecordRefHandle('020300', conProgress.subjectNo, conPro.major)">
										<i class="el-icon-document btn-icon"></i>
									</el-button>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.4 进度照片</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(progressPhotoRecord, idxs) in dataForm.progressPhotoRecords"
					:key="'progressPhotoRecord' + idxs">
					<el-col :span="24" class="set_sub" v-if="showSubjectName">{{ progressPhotoRecord.projectNo
					}}</el-col>
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(progressPhotoRecord.photoList)"
								:key="'progressPhoto' + rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.recNo"
										@dragstart="dragStart('progress', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('progress', idxs, rowIndex, colIndex)" @dragend="dragEnd()"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span class="report_font">{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button" size="small"
															:disabled="updateFlg || addFlg || basicVisible"
															@click="delImg(item.recNo)">删除</el-button>
														<el-button type="text" class="button" size="small"
															:disabled="updateFlg || addFlg || basicVisible"
															style="margin-right: 10px;"
															@click="updateImgContent(item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="选择照片" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="handleProgressPhotoSelect(progressPhotoRecord, idxs)">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row>
					<div v-if="!dataForm.progressPhotoRecords || dataForm.progressPhotoRecords.length === 0">
						<span style="color: #e7b243;;font-size: 14px;">暂无进度照片</span>
					</div>
				</el-row>
				<div ref="quality"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">3. 质量情况</div>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1 停止点检查（报验）情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-row>
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1.1 总体描述</span>
						</el-form-item>
					</el-row>
					<el-row>
						<draggable v-model="dataForm.stopPointCheckDesc" @start="onDragStart('030101')"
							@update="onDragEnd">
							<el-row :span="24" v-for="(stopPoint, index) in dataForm.stopPointCheckDesc"
								:key="'stop' + index">
								<el-tooltip placement="top" effect="light"
									:content="(stopPoint.updUserName || '') + ' ' + stopPoint.updDate"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(stopPoint)">
											<el-col :span="22" class="desc_span">
												{{ stopPoint.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="stopPoint.showButton == 1"
													@click="addOrUpdateSituation(stopPoint.recNo, '030101')">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn" v-if="stopPoint.showButton == 1"
													@click="deleteWeeklyReportFile(stopPoint.recNo, '030101')">
													×
												</el-button>
											</el-col>
										</el-col>
										<!-- <el-col :span="24">
											<div v-for="(photo, index1) in stopPoint.photoRecords"
												:key="'stopPhoto' + index1" style="margin-top: 20px;">
												<el-col :span="24" style="margin-left:20px;">
													<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
														fit="contain"></el-image>
												</el-col>
											</div>
										</el-col> -->
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in stopPoint.photoRecords"
												:key="'stopPhoto' + index1" style="margin-top: 20px;"
												v-if="stopPoint.photoRecords != undefined && stopPoint.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit="contain"></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="追加总体描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '030101')">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('030101')">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row>
					<el-row>
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1.2 主要质量问题跟踪处理情况</span>
						</el-form-item>
					</el-row>
					<el-row :span="24" style="padding-bottom: 10px">
						<el-row v-for="(qualityProblemDesc, index) in dataForm.qualityProblemDescList"
							:key="'qualityProblemDesc' + index">
							<el-col :span="24" class="set_sub" v-if="showSubjectName">{{ qualityProblemDesc.projectNo
							}}</el-col>
							<draggable v-model="qualityProblemDesc.reportDescInfos"
								@start="onDragStart('030102', index, '')" @update="onDragEnd">
								<el-row :span="24" style="margin-left:50px"
									v-for="(qualityProblem, index1) in qualityProblemDesc.reportDescInfos"
									:key="'qpd' + index1">
									<el-tooltip placement="top" effect="light"
										:content="(qualityProblem.updUserName || '') + ' ' + qualityProblem.updDate"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
											<el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col>
											<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(qualityProblem)">
												<el-col :span="22" class="desc_span">
													{{ qualityProblem.descContent }}
												</el-col>
												<!-- 占位 -->
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<el-col :span="1">
													<el-button type="text" style="margin-right: 10px;" class="desc_btn"
														v-if="qualityProblem.showButton == 1"
														@click="addOrUpdateSituation(qualityProblem.recNo, '030102')">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="qualityProblem.showButton == 1"
														@click="deleteWeeklyReportFile(qualityProblem.recNo, '030102')">
														×
													</el-button>
												</el-col>
											</el-col>
											<!-- <el-col :span="24">
												<div v-for="(photo, index2) in qualityProblem.photoRecords"
													:key="'qualityProblemPhoto' + index2" style="margin-top: 20px;">
													<el-col :span="24" style="margin-left:20px;">
														<el-image style="min-height: 220px;"
															:src="photo.compressedPathUri" fit="contain"></el-image>
													</el-col>
												</div>
											</el-col> -->
											<el-col :span="23" style="width:90%;margin-left:170px">
												<div v-for="(photo, index2) in qualityProblem.photoRecords"
													:key="'qualityProblemPhoto' + index2" style="margin-top: 20px;"
													v-if="qualityProblem.photoRecords != undefined && qualityProblem.photoRecords.length > 0">
													<el-col :span="9">
														<div style="margin:20px 20px 20px 20px ">
															<el-image style="height: 250px;"
																:src="photo.compressedPathUri" fit="contain"></el-image>
														</div>
													</el-col>
												</div>
											</el-col>
										</el-col>
									</el-tooltip>
								</el-row>
							</draggable>
							<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
								<el-tooltip content="追加处理情况" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="addOrUpdateSituation('', '030102', qualityProblemDesc.subjectNo)">
										<i class="el-icon-plus btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="选择描述内容" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="chooseQualityDescHandle('030102', qualityProblemDesc.subjectNo)">
										<i class="el-icon-search btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="上期数据参考" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="lastRecordRefHandle('030102', qualityProblemDesc.subjectNo)">
										<i class="el-icon-document btn-icon"></i>
									</el-button>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2 巡检检查情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2.1 总体描述</span>
						</el-form-item>
					</el-col>
					<draggable v-model="dataForm.patrolCheckDesc" @start="onDragStart('030201')" @update="onDragEnd">
						<el-row :span="24" v-for="(patroldesc, index) in dataForm.patrolCheckDesc"
							:key="'patroldesc' + index">
							<el-tooltip placement="top" effect="light"
								:content="(patroldesc.updUserName || '') + ' ' + patroldesc.updDate" :enterable="false">
								<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(patroldesc)">
										<el-col :span="22" class="desc_span">
											{{ patroldesc.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<!--非新增和修改时按钮操作-->
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="patroldesc.showButton == 1"
												@click="addOrUpdateSituation(patroldesc.recNo, '030201')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="patroldesc.showButton == 1"
												@click="deleteWeeklyReportFile(patroldesc.recNo, '030201')">
												×
											</el-button>
										</el-col>
									</el-col>
									<!-- <el-col :span="24">
										<div v-for="(photo, index1) in patroldesc.photoRecords"
											:key="'patroldescPhoto' + index1" style="margin-top: 20px;">
											<el-col :span="24" style="margin-left:20px;">
												<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</el-col>
										</div>
									</el-col> -->
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in patroldesc.photoRecords"
											:key="'patroldescPhoto' + index1" style="margin-top: 20px;"
											v-if="patroldesc.photoRecords != undefined && patroldesc.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit="contain"></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="追加总体描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030201')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030201')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2.2 突出问题跟踪处理情况</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-row v-for="(prominentProblemDesc, index) in dataForm.prominentProblemDescList" :key="index">
							<el-col :span="24" class="set_sub" v-if="showSubjectName">{{
								prominentProblemDesc.projectNo }}</el-col>
							<draggable v-model="prominentProblemDesc.reportDescInfos"
								@start="onDragStart('030202', index, '')" @update="onDragEnd">
								<el-row :span="24"
									v-for="(prominentproblem, index1) in prominentProblemDesc.reportDescInfos"
									:key="'ppds' + index1" style="margin-left:50px">
									<el-tooltip placement="top" effect="light"
										:content="(prominentproblem.updUserName || '') + ' ' + prominentproblem.updDate"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
											<el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col>
											<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(prominentproblem)">
												<el-col :span="22" class="desc_span">
													{{ prominentproblem.descContent }}
												</el-col>
												<!-- 占位 -->
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<el-col :span="1">
													<el-button type="text" style="margin-right: 10px;" class="desc_btn"
														v-if="prominentproblem.showButton == 1"
														@click="addOrUpdateSituation(prominentproblem.recNo, '030202')">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="prominentproblem.showButton == 1"
														@click="deleteWeeklyReportFile(prominentproblem.recNo, '030202')">
														×
													</el-button>
												</el-col>
											</el-col>
											<!-- <el-col :span="24">
												<div v-for="(photo, index1) in prominentproblem.photoRecords"
													:key="'prominentproblemPhoto' + index1" style="margin-top: 20px;">
													<el-col :span="24" style="margin-left:20px;">
														<el-image style="min-height: 220px;"
															:src="photo.compressedPathUri" fit="contain"></el-image>
													</el-col>
												</div>
											</el-col> -->
											<el-col :span="23" style="width:90%;margin-left:170px">
												<div v-for="(photo, index1) in prominentproblem.photoRecords"
													:key="'prominentproblemPhoto' + index1" style="margin-top: 20px;"
													v-if="prominentproblem.photoRecords != undefined && prominentproblem.photoRecords.length > 0">
													<el-col :span="9">
														<div style="margin:20px 20px 20px 20px ">
															<el-image style="height: 250px;"
																:src="photo.compressedPathUri" fit="contain"></el-image>
														</div>
													</el-col>
												</div>
											</el-col>
										</el-col>
									</el-tooltip>
								</el-row>
							</draggable>
							<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
								<el-tooltip content="追加处理情况" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="addOrUpdateSituation('', '030202', prominentProblemDesc.subjectNo)">
										<i class="el-icon-plus btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="选择描述内容" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="choosePatrolCheckDescHandle('030202', prominentProblemDesc.subjectNo)">
										<i class="el-icon-search btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="上期数据参考" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="lastRecordRefHandle('030202', prominentProblemDesc.subjectNo)">
										<i class="el-icon-document btn-icon"></i>
									</el-button>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3 不一致项报告及监理联系单处理及跟踪情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3.1 截止本周末共下发</span>
							<span class="summaryvalue2"> {{ dataForm.contactTotalNum }} </span>
							<span class="itemLabelspan"> 份监理联系单，已整改完成</span>
							<span class="summaryvalue2"> {{ dataForm.contactFinishNum }} </span>
							<span class="itemLabelspan"> 份。</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(contactItemRecord, index) in dataForm.contactItemRecordList"
					:key="'contactItemRecord' + index">
					<el-col class="set_sub">{{ contactItemRecord.projectNo }}</el-col>
					<el-col :span="24" style="margin-bottom: 10px;margin-top: 10px;">
						<el-table class="dataListTable" :data="contactItemRecord.itemRecordList" header-align="center"
							border style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="noticeNo" label="监理联系单编号" min-width="200" align="left">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" min-width="350" align="left">
							</el-table-column>
							<el-table-column prop="sendTime" label="下发日期" min-width="100" align="center">
							</el-table-column>
							<el-table-column prop="closeTime" label="封闭日期" min-width="100" align="center">
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="250" align="center" >
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3.2 截止本周末共下发</span>
							<span class="summaryvalue2"> {{ dataForm.noticeTotalNum }} </span>
							<span class="itemLabelspan"> 份监理通知单，已整改完成</span>
							<span class="summaryvalue2"> {{ dataForm.noticeFinishNum }} </span>
							<span class="itemLabelspan"> 份。</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(noticeItemRecord, index) in dataForm.noticeItemRecordList"
					:key="'noticeItemRecord' + index">
					<el-col class="set_sub">{{ noticeItemRecord.projectNo }}</el-col>
					<el-col :span="24" style="margin-bottom: 10px;margin-top: 10px;">
						<el-table class="dataListTable" :data="noticeItemRecord.itemRecordList" header-align="center"
							border style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="noticeNo" label="监理联系单编号" min-width="200" align="left">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" min-width="350" align="left">
							</el-table-column>
							<el-table-column prop="sendTime" label="下发日期" min-width="100" align="center">
							</el-table-column>
							<el-table-column prop="closeTime" label="封闭日期" min-width="100" align="center">
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="250" align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3.2 截止本周末共下发</span>
							<span class="summaryvalue2"> {{ dataForm.disAccordSendNum }} </span>
							<span class="itemLabelspan"> 份不一致报告。</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.4 质量照片</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(qualityPhotoRecord, idxs) in dataForm.qualityPhotoRecords"
					:key="'qualityPhotoRecord' + idxs">
					<el-col :span="24" class="set_sub" v-if="showSubjectName">{{ qualityPhotoRecord.projectNo
					}}</el-col>
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(qualityPhotoRecord.photoList)"
								:key="'qprRow' + rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.recNo"
										@dragstart="dragStart('quality', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('quality', idxs, rowIndex, colIndex)" @dragend="dragEnd()"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span class="report_font">{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button" size="small"
															:disabled="updateFlg || addFlg || basicVisible"
															@click="delImg(item.recNo)">删除</el-button>
														<el-button type="text" class="button" size="small"
															:disabled="updateFlg || addFlg || basicVisible"
															style="margin-right: 10px;"
															@click="updateImgContent(item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="选择照片" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="handleQualityPhotoSelect(qualityPhotoRecord, idxs)">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row v-if="!dataForm.qualityPhotoRecords || dataForm.qualityPhotoRecords.length === 0">
					<div>
						<span style="color: #e7b243;font-size: 14px;">暂无质量照片</span>
					</div>
				</el-row>
				<div ref="workfile"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">4. 文件审查情况
				</div>
				<el-row>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.fileCheckRecordTable" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :header-cell-style="headClass"
							:cell-style="{ padding: '0px' }">
							<el-table-column type="index" label="序号" align="center" width="80">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="center" min-width="250">
							</el-table-column>
							<el-table-column prop="examineStatusName" label="审查状态" align="center" min-width="150">
							</el-table-column>
							<el-table-column prop="examineSuggestion" label="审查意见" align="center"
								min-width="150">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<draggable v-model="dataForm.fileCheckRecords" @start="onDragStart('040000')" @update="onDragEnd">
					<el-row :span="24" v-for="(fileCheck, index) in dataForm.fileCheckRecords"
						:key="'fileCheck' + index">
						<el-tooltip placement="top" effect="light"
							:content="(fileCheck.updUserName || '') + ' ' + fileCheck.updDate" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(fileCheck)">
									<el-col :span="22" class="desc_span">
										{{ fileCheck.descContent }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="fileCheck.showButton == 1"
											@click="addOrUpdateSituation(fileCheck.recNo, '040000')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="fileCheck.showButton == 1"
											@click="deleteWeeklyReportFile(fileCheck.recNo, '040000')">
											×
										</el-button>
									</el-col>
								</el-col>
								<!-- <el-col :span="24">
									<div v-for="(photo, index1) in fileCheck.photoRecords"
										:key="'fileCheckPhoto' + index1" style="margin-top: 20px;">
										<el-col :span="24" style="margin-left:20px;">
											<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
												fit="contain"></el-image>
										</el-col>
									</div>
								</el-col> -->
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in fileCheck.photoRecords"
										:key="'fileCheckPhoto' + index1" style="margin-top: 20px;"
										v-if="fileCheck.photoRecords != undefined && fileCheck.photoRecords.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '040000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('040000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="design"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">5. 设计修改及审图意见落实情况</div>
				<el-row>
					<draggable v-model="dataForm.designEditDesc" @start="onDragStart('050000')" @update="onDragEnd">
						<el-row :span="24" v-for="(designdesc, index) in dataForm.designEditDesc"
							:key="'designdesc' + index">
							<el-tooltip placement="top"
								:content="(designdesc.updUserName || '') + ' ' + designdesc.updDate" effect="light"
								:enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(designdesc)">
										<el-col :span="22" class="desc_span">
											{{ designdesc.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="designdesc.showButton == 1"
												@click="addOrUpdateSituation(designdesc.recNo, '050000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="designdesc.showButton == 1"
												@click="deleteWeeklyReportFile(designdesc.recNo, '050000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<!-- <el-col :span="24">
										<div v-for="(photo, index1) in designdesc.photoRecords"
											:key="'designdescPhoto' + index1" style="margin-top: 20px;">
											<el-col :span="24" style="margin-left:20px;">
												<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</el-col>
										</div>
									</el-col> -->
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in designdesc.photoRecords"
											:key="'designdescPhoto' + index1" style="margin-top: 20px;"
											v-if="designdesc.photoRecords != undefined && designdesc.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit="contain"></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="追加设计修改及审图意见落实情况" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="hse"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">6. HSE情况</div>
				<el-row>
					<draggable v-model="dataForm.hseInfoDesc" @start="onDragStart('060000')" @update="onDragEnd">
						<el-row :span="24" v-for="(hse, index) in dataForm.hseInfoDesc" :key="'hse' + index">
							<el-tooltip placement="top" effect="light"
								:content="(hse.updUserName || '') + ' ' + hse.updDate" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(hse)">
										<el-col :span="22" class="desc_span">
											{{ hse.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="hse.showButton == 1"
												@click="addOrUpdateSituation(hse.recNo, '060000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="hse.showButton == 1"
												@click="deleteWeeklyReportFile(hse.recNo, '060000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<!-- <el-col :span="24">
										<div v-for="(photo, index1) in hse.photoRecords" :key="'hsePhoto' + index1"
											style="margin-top: 20px;">
											<el-col :span="24" style="margin-left:20px;">
												<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</el-col>
										</div>
									</el-col> -->
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in hse.photoRecords" :key="'hsePhoto' + index1"
											style="margin-top: 20px;"
											v-if="hse.photoRecords != undefined && hse.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit="contain"></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="追加HSE情况" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '060000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('060000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="meet"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">7. 会议情况
				</div>
				<draggable v-model="dataForm.meetingDesc" @start="onDragStart('070000')" @update="onDragEnd">
					<el-row :span="24" v-for="(meeting, index) in dataForm.meetingDesc" :key="'meet' + index">
						<el-tooltip placement="top" effect="light"
							:content="(meeting.updUserName || '') + ' ' + meeting.updDate" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(meeting)">
									<el-col :span="22" class="desc_span">
										{{ meeting.descContent }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="meeting.showButton == 1"
											@click="addOrUpdateSituation(meeting.recNo, '080000')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="meeting.showButton == 1"
											@click="deleteWeeklyReportFile(meeting.recNo, '080000')">
											×
										</el-button>
									</el-col>
								</el-col>
								<!-- <el-col :span="24">
									<div v-for="(photo, index1) in meeting.photoRecords" :key="'meetingPhoto' + index1"
										style="margin-top: 20px;">
										<el-col :span="24" style="margin-left:20px;">
											<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
												fit="contain"></el-image>
										</el-col>
									</div>
								</el-col> -->
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in meeting.photoRecords" :key="'meetingPhoto' + index1"
										style="margin-top: 20px;"
										v-if="meeting.photoRecords != undefined && meeting.photoRecords.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加会议情况 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '070000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从监理会议模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectMeetingHandle('070000')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从协调记录模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectCoordinateHandle('070000')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('070000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="other"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">8. 其他需要说明的问题</div>
				<el-row>
					<draggable v-model="dataForm.otherDesc" @start="onDragStart('080000')" @update="onDragEnd">
						<el-row :span="24" v-for="(othdesc, index) in dataForm.otherDesc" :key="'other' + index">
							<el-tooltip placement="top" effect="light"
								:content="(othdesc.updUserName || '') + ' ' + othdesc.updDate" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(othdesc)">
										<el-col :span="22" class="desc_span">
											{{ othdesc.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="othdesc.showButton == 1"
												@click="addOrUpdateSituation(othdesc.recNo, '080000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="othdesc.showButton == 1"
												@click="deleteWeeklyReportFile(othdesc.recNo, '080000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<!-- <el-col :span="24">
										<div v-for="(photo, index1) in othdesc.photoRecords"
											:key="'otherPhoto' + index1" style="margin-top: 20px;">
											<el-col :span="24" style="margin-left:20px;">
												<el-image style="min-height: 220px;" :src="photo.compressedPathUri"
													fit="contain"></el-image>
											</el-col>
										</div>
									</el-col> -->
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in othdesc.photoRecords"
											:key="'otherPhoto' + index1" style="margin-top: 20px;"
											v-if="othdesc.photoRecords != undefined && othdesc.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit="contain"></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="追加其他需要说明的问题" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '080000', '', '')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('080000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="enclosure"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">9. 随周报发送的附件</div>
				<el-row>
					<el-col :span="2">
						<el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-upload"
							@click="editHandle()">添加附件</el-button>
					</el-col>
					<el-col :span="4">
						<el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-refresh"
							@click="refreshEnclosureFiles()">生成/刷新附件</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table ref="singleTable" class="dataListTable" :data="enclosureList" header-align="center"
							style="width: 100%;font-size: 12px;" empty-text="无附件"
							header-cell-class-name="dataListTHeader" border :cell-style="{ padding: '0px' }"
							row-key="recNo" :header-cell-style="headClass">
							<el-table-column type="index" label="序号" align="center" width="60">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="left" min-width="250">
							</el-table-column>
							<el-table-column prop="remark" label="备注" align="center" min-width="150">
							</el-table-column>
							<el-table-column label="操作" align="center" width="300">
								<template slot-scope="scope">
									<el-button v-preventReClick type="danger" size="small"
										@click="downloadHandle(scope.row.filePathUri, scope.row.fileName)"
										v-if="scope.row.filePathUri">下载</el-button>
									<el-button v-preventReClick type="warning" size="small"
										@click="editHandle(scope.row.recNo)">修改</el-button>
									<el-button v-preventReClick type="danger" size="small"
										@click="deleteHandle(scope.row.recNo)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-card>
			<!-- <el-card style="margin-top: 20px; height: 100%; padding-top: 30px;">
				<el-row>
					<el-col :span="7" class="col-set_border1">
						<el-form-item label="报告人" label-width="120px" class="item">
							<el-input class="selItemInput" v-model="dataForm.reportMan" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="7" class="col-set_border2">
						<el-form-item label="日期" label-width="120px" class="item">
							<el-date-picker class="selItemInput" v-model="dataForm.reportTime" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="7" class="col-set_border3">
						<el-form-item label="项目总监" label-width="120px" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectDirector"
								placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="7" class="col-set_border4">
						<el-form-item label="日期" label-width="120px" class="item">
							<el-date-picker class="selItemInput" v-model="dataForm.projectDirectorTime" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card> -->
		</el-form>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'basic'" @click="jump_to_basic" style="bottom: 187px;"></div>
			<div class="set_btn_border" v-if="menuId === 'basic'" @click="jump_to_basic" style="bottom: 187px;"></div>
			<div class="set_menu" style="bottom: 185px;" @click="jump_to_basic">基本信息</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'overview'" @click="jump_to_overview" style="bottom: 167px;"></div>
			<div class="set_btn_border" v-if="menuId === 'overview'" @click="jump_to_overview" style="bottom: 167px;">
			</div>
			<div class="set_menu" style="bottom: 165px;" @click="jump_to_overview">1.概述</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'progress'" @click="jump_to_progress" style="bottom: 147px;"></div>
			<div class="set_btn_border" v-if="menuId === 'progress'" @click="jump_to_progress" style="bottom: 147px;">
			</div>
			<div class="set_menu" style="bottom: 145px;" @click="jump_to_progress">2.施工进度情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'quality'" @click="jump_to_quality" style="bottom: 127px;"></div>
			<div class="set_btn_border" v-if="menuId === 'quality'" @click="jump_to_quality" style="bottom: 127px;">
			</div>
			<div class="set_menu" style="bottom: 125px;" @click="jump_to_quality">3.质量情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'workfile'" @click="jump_to_workFile" style="bottom: 107px;"></div>
			<div class="set_btn_border" v-if="menuId === 'workfile'" @click="jump_to_workFile" style="bottom: 107px;">
			</div>
			<div class="set_menu" style="bottom: 105px;" @click="jump_to_workFile">4.文件审查情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'design'" @click="jump_to_design" style="bottom: 87px;"></div>
			<div class="set_btn_border" v-if="menuId === 'design'" @click="jump_to_design" style="bottom: 87px;"></div>
			<div class="set_menu" style="bottom: 85px;" @click="jump_to_design">5.设计修改及审图意见落实情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'hse'" @click="jump_to_hse" style="bottom: 67px;"></div>
			<div class="set_btn_border" v-if="menuId === 'hse'" @click="jump_to_hse" style="bottom: 67px;"></div>
			<div class="set_menu" style="bottom: 65px;" @click="jump_to_hse">6.HSE情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'meet'" @click="jump_to_meet" style="bottom: 47px;"></div>
			<div class="set_btn_border" v-if="menuId === 'meet'" @click="jump_to_meet" style="bottom: 47px;"></div>
			<div class="set_menu" style="bottom: 45px;" @click="jump_to_meet">7.会议情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_btn_border" v-if="menuId === 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_menu" style="bottom: 25px;" @click="jump_to_other">8.其他需要说明的问题</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;"></div>
			<div class="set_btn_border" v-if="menuId === 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;">
			</div>
			<div class="set_menu" style="bottom: 5px;" @click="jump_to_enclosure">9.随周报发送的附件</div>
		</el-row>

		<el-dialog title="添加照片" :visible.sync="dialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="工程编号">
							<el-select id="photoPojectNo" v-model="photoPojectNo" placeholder="请选择">
								<el-option v-for="item in subjectList" :key="item.displayValue" :label="item.projectNo"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="photoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in photoList" :key="'afds' + index">
								<el-image style="width: 100%; height: 100%" :src="item.photoPathUri"
									fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delPhotoImg(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadTempImg" :action="action"
								:http-request="uploadTempImg" accept="image/jpeg,image/png,image/jpg"
								v-if="!photoList || photoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="dialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="savePhotoList">确 定</el-button>
			</span>

		</el-dialog>
		<el-dialog title="添加照片" :visible.sync="meetPhotoDialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="meetPhotoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in meetPhotoList" :key="'meetPhoto' + index">
								<el-image style="width: 100%; height: 100%" :src="item.photoFilePathUrl"
									fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delMeetDialogPhoto(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadMeetImg" :action="action"
								:http-request="uploadMeetImg" accept="image/jpeg,image/png,image/jpg"
								v-if="!meetPhotoList || meetPhotoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="meetPhotoDialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="saveMeetPhotoList">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 质量进度照片内容修改 -->
		<el-dialog title="修改描述" :visible.sync="updateImgContentVisable" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="">
							<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
								v-model="updatePhotoContent" placeholder="请填写" style="width:420px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small"
					@click="saveImgContent">保存</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="updateImgContentVisable = false">取
					消</el-button>
			</span>
		</el-dialog>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getEnclosureList"></add-or-update>
		<quality-progress-photo-select v-if="qpPhotoSelectVisible" ref="qpPhotoSelect"
			@selectItems="margeSelectItems"></quality-progress-photo-select>
		<add-or-update-situation v-if="addOrUpdateSituationVisible" ref="addOrUpdateSituation"
			@refreshDataList="getWeeklySituationList"></add-or-update-situation>
		<choose-progress-record v-if="chooseProgressKindVisible" ref="chooseProgressRecord"
			@refreshDataList="getWeeklySituationList"></choose-progress-record>
		<last-record-ref v-if="lastRecordRefVisible" ref="lastRecordRef"
			@refreshDataList="getWeeklySituationList"></last-record-ref>
		<choose-test-record v-if="chooseQualityDescVisible" ref="chooseTestRecord"
			@refreshDataList="getWeeklySituationList"></choose-test-record>
		<choose-inspection v-if="choosePatrolCheckDescVisible" ref="chooseInspection"
			@refreshDataList="getWeeklySituationList"></choose-inspection>
		<meeting-select v-if="meetingSelectVisible" ref="meetingSelect"
			@selectMeetingItems="margeSelectMeetingItems"></meeting-select>
		<select-coordinate v-if="selectCoordinateVisible" ref="selectCoordinate"
			@refreshDataList="getWeeklySituationList"></select-coordinate>
	</div>
</template>
<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js";
import AddOrUpdate from './enclosure-add-or-update'
import QualityProgressPhotoSelect from './quality-progress-photo-select'
import Sortable from "sortablejs";
import draggable from 'vuedraggable';
import AddOrUpdateSituation from './add-or-update-situation.vue'
import ChooseProgressRecord from './choose-progress-record.vue'
import LastRecordRef from './last-record-ref.vue'
import ChooseTestRecord from './choose-test-record.vue'
import ChooseInspection from './choose-inspection.vue'
import SelectCoordinate from './select-coordinate.vue'
import MeetingSelect from './meeting-select.vue'
export default {
	data() {
		return {
			basicVisible: false,
			addOrUpdateVisible: false,
			qpPhotoSelectVisible: false,
			chooseProgressKindVisible: false,
			meetingSelectVisible: false,
			selectCoordinateVisible: false,
			chooseQualityDescVisible: false,
			choosePatrolCheckDescVisible: false,
			lastRecordRefVisible: false,
			photoFlag: 0,
			dialogVisible: false,
			meetPhotoDialogVisible: false,
			addOrUpdateSituationVisible: false,
			lastRecordRefVisible: false,
			showSubjectName: false,
			meetPhotoListIndex: 0,
			addImg: addImg,
			recNo: '',
			beginTime: '',
			action: '',
			endTime: '',
			photoList: [],
			meetPhotoList: [],
			enclosureList: [],
			projectDesc: [],
			majorList: [],
			subjectList: {},
			photoPojectNo: '',
			subjectNo: '',
			photoContent: '',
			meetPhotoContent: '',
			workNo: $common.getItem("workNo"),
			dataRule: {},
			dataForm: {
				projectInfo: {
					projectName: ''
				}
			},
			photoViewCol: 6,
			draggedItem: {},
			selectPhotoType: '',
			recNos: [],
			updateImgContentVisable: false,
			photoType: '',
			photoRecNo: '',
			updatePhotoContent: '',
			contentIdx: '',
			menuId: 'basic',
			addFlg: false,
			updateFlg: false,
			updateDescRecNo: '',
			qpPhotoIndex: 0,
			updateDataType: '',
			updateIndex: '',
			updateIndex1: '',
		};
	},
	components: {
		AddOrUpdate,
		QualityProgressPhotoSelect,
		draggable,
		AddOrUpdateSituation,
		ChooseProgressRecord,
		LastRecordRef,
		ChooseTestRecord,
		ChooseInspection,
		MeetingSelect,
		SelectCoordinate
	},
	mounted() {
		this.recNo = this.$route.query.recNo;
		this.getSubjectDropDown();
		this.getMajorList()
		this.dragSort();
		this.getEnclosureList();
		this.getWeekInfo();
	},
	methods: {
		getFileItemBgStyle(item) {
			if (item && item.oriRecNo) {
				return { backgroundColor: 'rgb(249 248 209 / 69%)' };
			}
			return {};
		},
		getCurrentDate() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			if (mm < 10) {
				mm = '0' + mm;
			}
			return yy + '.' + mm + '.' + dd;
		},
		objectTestRecordMethod({ row, column, rowIndex, columnIndex }) {
			// if (columnIndex === 0) {
			// 	// this.tableData  修改
			// 	const _row = (this.flitterSubjectNo(this.dataForm.testItemRecords).one)[rowIndex];
			// 	const _col = _row > 0 ? 1 : 0;
			// 	return {
			// 		rowspan: _row,
			// 		colspan: _col
			// 	};
			// }
		},
		objectInspectionMethod({ row, column, rowIndex, columnIndex }) {
			// if (columnIndex === 0) {
			// 	// this.tableData  修改
			// 	const _row = (this.flitterSubjectNo(this.dataForm.patrolItemRecords).one)[rowIndex];
			// 	const _col = _row > 0 ? 1 : 0;
			// 	return {
			// 		rowspan: _row,
			// 		colspan: _col
			// 	};
			// }
		},
		flitterSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectNo === arr[index - 1].subjectNo) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		onDragStart(dataType, index, index1) {
			this.updateDataType = dataType;
			this.updateIndex = index;
			this.updateIndex1 = index1;
		},
		onDragEnd(event) {
			event.preventDefault();
			// 拖拽结束后的处理逻辑
			let records = [];
			if (this.updateDataType == '010100') {
				// 1.1 重要事项描述
				records = this.dataForm.projectDesc
			} else if (this.updateDataType == '020300') {
				// 2.3 详细进度路况
				records = this.dataForm.constructionProgress[this.updateIndex].conProgressList[this.updateIndex1].descProgressList
			} else if (this.updateDataType == '030101') {
				// 3.1.1 停止点检查（报验）情况 总体描述
				records = this.dataForm.stopPointCheckDesc
			} else if (this.updateDataType == '030102') {
				// 3.1.1 停止点检查（报验）情况 主要质量问题跟踪处理情况
				records = this.dataForm.qualityProblemDescList[this.updateIndex].reportDescInfos;
			} else if (this.updateDataType == '030201') {
				// 3.2.1 巡检检查情况 总体描述
				records = this.dataForm.patrolCheckDesc
			} else if (this.updateDataType == '030202') {
				// 3.2.1 巡检检查情况 突出问题跟踪处理情况
				records = this.dataForm.prominentProblemDescList[this.updateIndex].reportDescInfos;
			} else if (this.updateDataType == '040000') {
				// 4.文件审查情况
				records = this.dataForm.fileCheckRecords
			} else if (this.updateDataType == '050000') {
				// 5.设计修改及审图意见落实情况
				records = this.dataForm.designEditDesc
			} else if (this.updateDataType == '060000') {
				// 6.HSE情况
				records = this.dataForm.hseInfoDesc
			} else if (this.updateDataType == '070000') {
				// 7.会议情况
				records = this.dataForm.meetingDesc
			} else if (this.updateDataType == '080000') {
				// 8. 其他需要说明的问题
				records = this.dataForm.otherDesc
			}
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportdescinfo/sort",
				method: "post",
				data: this.$http.adornData({
					dataType: this.updateDataType,
					weeklyRecNo: this.recNo,
					records: records
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.updateDataType = ''
							this.getWeeklySituationList();
						}
					});
				}
			});
		},
		dragSort() {
			const el = this.$refs.singleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
			this.sortable = Sortable.create(el, {
				onEnd: e => {	//onEnd是结束拖拽时触发，onUpdate是列表内元素顺序更新的时候触发，更多请看文末配置项
					//e.oldIndex为拖动一行原来的位置，e.newIndex为拖动后新的位置
					const targetRow = this.enclosureList.splice(e.oldIndex, 1)[0];
					this.enclosureList.splice(e.newIndex, 0, targetRow);
					let recNo = this.enclosureList[e.newIndex].recNo;//拖动行的id
					// 后端发送请求排序
					this.$http({
						url: this.$store.state.httpUrl + "/business/weekreportenclosure/sort",
						method: "POST",
						data: this.$http.adornData({
							enclosureList: this.enclosureList,
							workNo: $common.getItem("workNo"),
							detailRecNo: this.recNo
						}),
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getEnclosureList()
								}
							})
						}
					});
				}
			})
		},
		/* 照片拖拽 begin */
		cardRows(photoList) {
			const rows = [];
			if (photoList != null) {
				for (let i = 0; i < photoList.length; i += this.photoViewCol) {
					rows.push(photoList.slice(i, i + this.photoViewCol));
				}
			}
			return rows;
		},
		dragStart(type, idxs, rowIndex, colIndex) {
			this.draggedItem = { type: type, idxs: idxs, row: rowIndex, col: colIndex };
		},
		drop(type, idxs, rowIndex, colIndex) {
			if (type !== this.draggedItem.type || idxs !== this.draggedItem.idxs) {
				return
			}
			const x = this.draggedItem.row * this.photoViewCol + this.draggedItem.col
			const y = rowIndex * this.photoViewCol + colIndex
			let photoList = []
			if (type === 'progress') {
				photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			} else if (type === 'quality') {
				photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			} else if (type === 'meeting') {
				photoList = this.dataForm.meetingDesc[idxs].photoRecords
			}
			if (x == y) {
				return
			} else if (x < y) {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			} else {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			}

			if (photoList != undefined && photoList.length > 1) {
				// 直接保存至db
				let url = "";
				if (type === 'progress' || type === 'quality') {
					url = "/business/weeklyreportphoto/sort"
					// 质量照片和进度照片	
				} else if (type === 'meeting') {
					// 会议照片
					url = "/business/weeklyreportdescphoto/sort"
				}
				this.$http({
					url: this.$store.state.httpUrl + url,
					method: "POST",
					data: this.$http.adornData({
						records: photoList,
						weeklyRecNo: this.recNo
					}),
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getWeeklyPhotoList();
							}
						})
					}
				});
			}

		},
		dragEnd() {
			this.draggedItem = {};
		},
		updateBasicHandle() {
			this.basicVisible = true;
		},
		cancelSaveBasicHandle() {
			this.getWeekInfo()
			// this.basicVisible = false;
		},
		saveBasicHandle() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportinfo/updateWeeklyBasic",
				method: 'post',
				data: this.$http.adornData({
					recNo: this.weeklyRecNo,
					weeklyRecNo: this.dataForm.weeklyRecNo,
					weeklyName: this.dataForm.weeklyName,
					projectNum: this.dataForm.projectNum,
					projectSubjectNo: this.dataForm.projectSubjectNo,
					reportMan: this.dataForm.reportMan,
					reportTime: this.dataForm.reportTime,
					projectDirector: this.dataForm.projectDirector,
					projectDirectorTime: this.dataForm.projectDirectorTime,
					qualitySituation: this.dataForm.qualitySituation,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.basicVisible = false;
							this.getWeekInfo()
						}
					})
				}
			})
		},
		saveDescHandle(reportDesc) {
			let _url = "/business/weeklyreportdescinfo/save";
			if (reportDesc.recNo) {
				reportDesc.updUserName = $common.getItem("userName")
				_url = "/business/weeklyreportdescinfo/update";
			}
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(reportDesc)
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.getWeekInfo();
						}
					});
				}
			});
		},
		chooseProgressKindHandle(dataType, subjectNo, major) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo, major);
			this.chooseProgressKindVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseProgressRecord.init(this.recNo, sort + 1, dataType, subjectNo, major, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		chooseQualityDescHandle(dataType, subjectNo) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo);
			this.chooseQualityDescVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseTestRecord.init(this.recNo, sort + 1, dataType, subjectNo, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		choosePatrolCheckDescHandle(dataType, subjectNo) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo);
			this.choosePatrolCheckDescVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseInspection.init(this.recNo, sort + 1, dataType, subjectNo, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		selectMeetingHandle(dataType) {
			this.meetingSelectVisible = true
			// 获取会议情况来源ids
			let meetIds = ''
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sourceType != null && meetingDesc[i].sourceType == '1' && meetingDesc[i].sourceId != null) {
						meetIds = meetIds + meetingDesc[i].sourceId
						if (i < meetingDesc.length - 1) {
							meetIds = meetIds + ','
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
			})
		},
		selectCoordinateHandle(dataType) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			// 获取协调记录来源ids
			let coordinateNos = ''
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sourceType != null && meetingDesc[i].sourceType == '2' && meetingDesc[i].sourceId != null) {
						coordinateNos = coordinateNos + meetingDesc[i].sourceId
						if (i < meetingDesc.length - 1) {
							coordinateNos = coordinateNos + ','
						}
					}
				}
			}
			this.selectCoordinateVisible = true
			this.$nextTick(() => {
				this.$refs.selectCoordinate.init(this.recNo, sort + 1, dataType, coordinateNos, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		margeSelectMeetingItems(items) {
			this.meetingSelectVisible = false;
			let meetIds = items.map((item) => item.meetId);
			this.saveMeetingFiles(meetIds)
		},
		saveMeetingFiles(meetIds) {
			// 计算最大排序值
			let sort = 0;
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sort > sort) {
						sort = meetingDesc[i].sort
					}
				}
			}
			let _url = "/business/weeklyreportdescinfo/saveMeetingFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					weeklyRecNo: this.recNo,
					meetIds: meetIds,
					sort: sort + 1
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getWeeklySituationList();
				}
			});
		},
		lastRecordRefHandle(dataType, subjectNo, major) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo, major);
			this.lastRecordRefVisible = true;
			this.$nextTick(() => {
				this.$refs.lastRecordRef.init(this.recNo, sort + 1, dataType, subjectNo, major)
			})
		},
		delImg(recNo) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportphoto/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getWeeklyPhotoList();
							}
						})
					}
				});
			})
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
		updateImgContent(recNo, photoContent) {
			this.updateImgContentVisable = true;
			this.photoRecNo = recNo;
			this.updatePhotoContent = photoContent;
		},
		saveImgContent() {
			// 直接更新到db
			let _url = "/business/weeklyreportphoto/updatePhotoContent";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.photoRecNo,
					photoRemark: this.updatePhotoContent,
					weeklyRecNo: this.recNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.updateImgContentVisable = false
							this.getWeeklyPhotoList()
						}
					})
				}
			});
		},
		addOrUpdateSituation(recNo, dataType, subjectNo, major) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo, major);
			this.addOrUpdateSituationVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateSituation.init(this.recNo, recNo, sort + 1, dataType, subjectNo, major)
			})
		},
		getMaxSort(dataType, subjectNo, major) {
			// 计算最大排序值
			let sort = 0;
			if (dataType === '010100' && this.dataForm.projectDesc != undefined && this.dataForm.projectDesc.length > 0) {
				for (var i = 0; i < this.dataForm.projectDesc.length; i++) {
					if (this.dataForm.projectDesc[i].sort > sort) {
						sort = this.dataForm.projectDesc[i].sort
					}
				}
			} else if (dataType === '020300' && this.dataForm.constructionProgress != undefined && this.dataForm.constructionProgress.length > 0) {
				for (var i = 0; i < this.dataForm.constructionProgress.length; i++) {
					let constructionProgress = this.dataForm.constructionProgress[i];
					if (constructionProgress.subjectNo === subjectNo) {
						let conProgressList = constructionProgress.conProgressList;
						for (var j = 0; j < conProgressList.length; j++) {
							if (conProgressList[j].major === major) {
								let descProgressList = conProgressList[j].descProgressList;
								for (var k = 0; k < descProgressList.length; k++) {
									if (descProgressList[k].sort > sort) {
										sort = descProgressList[k].sort
									}
								}
							}
						}
					}
				}
			} else if (dataType === '030101' && this.dataForm.stopPointCheckDesc != undefined && this.dataForm.stopPointCheckDesc.length > 0) {
				for (var i = 0; i < this.dataForm.stopPointCheckDesc.length; i++) {
					if (this.dataForm.stopPointCheckDesc[i].sort > sort) {
						sort = this.dataForm.stopPointCheckDesc[i].sort
					}
				}
			} else if (dataType === '030102' && this.dataForm.qualityProblemDescList != undefined && this.dataForm.qualityProblemDescList.length > 0) {
				for (var i = 0; i < this.dataForm.qualityProblemDescList.length; i++) {
					let qualityProblemDesc = this.dataForm.qualityProblemDescList[i];
					if (qualityProblemDesc.subjectNo === subjectNo) {
						let reportDescInfos = qualityProblemDesc.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '030201' && this.dataForm.patrolCheckDesc != undefined && this.dataForm.patrolCheckDesc.length > 0) {
				for (var i = 0; i < this.dataForm.patrolCheckDesc.length; i++) {
					if (this.dataForm.patrolCheckDesc[i].sort > sort) {
						sort = this.dataForm.patrolCheckDesc[i].sort
					}
				}
			} else if (dataType === '030202' && this.dataForm.prominentProblemDescList != undefined && this.dataForm.prominentProblemDescList.length > 0) {
				for (var i = 0; i < this.dataForm.prominentProblemDescList.length; i++) {
					let prominentProblem = this.dataForm.prominentProblemDescList[i];
					if (prominentProblem.subjectNo === subjectNo) {
						let reportDescInfos = prominentProblem.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '040000' && this.dataForm.fileCheckRecords != undefined && this.dataForm.fileCheckRecords.length > 0) {
				for (var i = 0; i < this.dataForm.fileCheckRecords.length; i++) {
					if (this.dataForm.fileCheckRecords[i].sort > sort) {
						sort = this.dataForm.fileCheckRecords[i].sort
					}
				}
			} else if (dataType === '050000' && this.dataForm.designEditDesc != undefined && this.dataForm.designEditDesc.length > 0) {
				for (var i = 0; i < this.dataForm.designEditDesc.length; i++) {
					if (this.dataForm.designEditDesc[i].sort > sort) {
						sort = this.dataForm.designEditDesc[i].sort
					}
				}
			} else if (dataType === '060000' && this.dataForm.hseInfoDesc != undefined && this.dataForm.hseInfoDesc.length > 0) {
				for (var i = 0; i < this.dataForm.hseInfoDesc.length; i++) {
					if (this.dataForm.hseInfoDesc[i].sort > sort) {
						sort = this.dataForm.hseInfoDesc[i].sort
					}
				}
			} else if (dataType === '070000' && this.dataForm.meetingDesc != undefined && this.dataForm.meetingDesc.length > 0) {
				for (var i = 0; i < this.dataForm.meetingDesc.length; i++) {
					if (this.dataForm.meetingDesc[i].sort > sort) {
						sort = this.dataForm.meetingDesc[i].sort
					}
				}
			} else if (dataType === '080000' && this.dataForm.otherDesc != undefined && this.dataForm.otherDesc.length > 0) {
				for (var i = 0; i < this.dataForm.otherDesc.length; i++) {
					if (this.dataForm.otherDesc[i].sort > sort) {
						sort = this.dataForm.otherDesc[i].sort
					}
				}
			}
			return sort;
		},
		/* 照片拖拽 end */
		downloadHandle(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			// 正则匹配：判断文件名是否包含 .后缀名（支持常见后缀，且不是最后一个字符）
			const hasSuffix = /\.[a-zA-Z0-9]+$/.test(filename);
			// 如果已经有后缀，直接返回原文件名；没有则拼接URL里的后缀
			if (hasSuffix) {
				return filename;
			}
			// 没有后缀，执行原逻辑拼接
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		editHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.recNo)
			})
		},
		refreshEnclosureFiles() {
			let _url = "/business/weeklyreportinfo/refreshEnclosureFiles/" + this.recNo;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getEnclosureList();
				}
			});
		},
		handleProgressPhotoSelect(progressPhotoRecord, index) {
			this.selectPhotoType = '2'
			this.qpPhotoSelectVisible = true
			let photoList = progressPhotoRecord.photoList;
			this.qpPhotoIndex = index
			// 获取现场照片来源ids
			let recNos = ''
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					recNos = recNos + photoList[i].sourceId;
					if (i < photoList.length - 1) {
						recNos = recNos + ','
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("2", this.dataForm.beginTime, this.dataForm.endTime, recNos, progressPhotoRecord.subjectNo)
			})
		},
		handleQualityPhotoSelect(qualityPhotoRecord, index) {
			this.selectPhotoType = '1'
			this.qpPhotoSelectVisible = true
			let photoList = qualityPhotoRecord.photoList;
			this.qpPhotoIndex = index
			// 获取现场照片来源ids
			let recNos = ''
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					recNos = recNos + photoList[i].sourceId;
					if (i < photoList.length - 1) {
						recNos = recNos + ','
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("1", this.dataForm.beginTime, this.dataForm.endTime, recNos, qualityPhotoRecord.subjectNo)
			})
		},
		margeSelectItems(items) {
			let records = []
			let maxSort = 0;
			let photoList = []
			if (this.selectPhotoType === '2') {
				photoList = this.dataForm.progressPhotoRecords[this.qpPhotoIndex].photoList
			} else if (this.selectPhotoType === '1') {
				photoList = this.dataForm.qualityPhotoRecords[this.qpPhotoIndex].photoList

			}
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					if (photoList[i].sort > maxSort) {
						maxSort = photoList[i].sort
					}
				}
			}
			if (items != undefined && items.length > 0) {
				for (var i = 0; i < items.length; i++) {
					let progressPhotot = {
						detailRecNo: this.dataForm.weeklyDetailRecNo,
						photoKind: this.selectPhotoType,
						subjectNo: items[i].subjectNo,
						sort: maxSort + 1 + i,
						photoPath: items[i].photoFilePath,
						thumbnailPath: items[i].thumbnailPath,
						compressedPath: items[i].compressedPath,
						sourceId: items[i].recNo,
						photoRemark: items[i].photoContent,
						major: items[i].majorCode,
						photoPathUri: items[i].photoPathUri
					}
					records.push(progressPhotot)
				}
			}
			this.saveBatchWeeklyQPPhoto(records);
		},
		saveBatchWeeklyQPPhoto(records) {
			let _url = "/business/weeklyreportphoto/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					records: records,
					weeklyRecNo: this.recNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.qpPhotoSelectVisible = false;
							this.getWeeklyPhotoList();
						}
					});
				}
			});
		},
		getWeeklyPhotoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportinfo/getWeeklyPhotoList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.progressPhotoRecords = data.body.progressPhotoRecords
					this.dataForm.qualityPhotoRecords = data.body.qualityPhotoRecords
				}
			});
		},
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weekreportenclosure/delete",
					method: "POST",
					data: this.$http.adornData([id], false),
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getEnclosureList()
							}
						})
					}
				});
			})
		},
		getEnclosureList() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/weekreportenclosure/listByWeeklyId`,
				method: 'get',
				params: {
					workNo: $common.getItem("workNo"),
					detailRecNo: this.recNo
				}
			}).then(({ data }) => {
				if (data.resultCode === 200) {
					// this.enclosureList = data.body
					// 附件列表，重新设置附件名称
					let enclosureFiles = []
					if (data.body != undefined && data.body.length > 0) {
						for (var i = 0; i < data.body.length; i++) {
							data.body[i].fileName = '附件' + (i + 1) + "：" + data.body[i].fileName
							enclosureFiles.push(data.body[i]);
						}
					}
					this.enclosureList = enclosureFiles;
				}
			})
		},
		delPhotoImg(index) {
			this.photoList.splice(index, 1);
		},
		delMeetDialogPhoto(index) {
			this.meetPhotoList.splice(index, 1);
		},
		addPhoto(flag) {
			this.photoList = [];
			this.photoPojectNo = '';
			this.photoContent = '';
			this.dialogVisible = true;
			this.photoFlag = flag;
		},
		addMeetingDescPhoto(idx) {
			this.meetPhotoListIndex = idx
			this.meetPhotoList = [];
			this.meetPhotoContent = '';
			this.meetPhotoDialogVisible = true;
		},
		uploadTempImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadTempImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.photoList.push({
						photoFilePath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		uploadMeetImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadMeetImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.meetPhotoList.push({
						photoFilePath: res.body.fileSavePath,
						photoFilePathUrl: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		getMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.majorList = data.body;
				}
			});
		},
		getProjectCode(projectNo) {
			for (var item in this.subjectList) {
				if (this.subjectList[item].displayValue == projectNo) {
					return this.subjectList[item].projectNo
				}
			}
		},
		savePhotoList() {
			if (!this.photoPojectNo) {
				this.$message.error("请选择工程编号");
				return;
			}
			if (!this.photoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.photoList || this.photoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}

			if (this.photoFlag === 1) {
				let flag = false;
				if (this.dataForm.progressPhotoRecords && this.dataForm.progressPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.progressPhotoRecords.length; i++) {
						if (this.dataForm.progressPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoFilePath,
								photoPathUri: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.progressPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let progressPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoFilePath,
						photoPathUri: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(progressPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: photoList
					};
					this.dataForm.progressPhotoRecords.push(item);
				}
			} else {
				let flag = false;
				if (this.dataForm.qualityPhotoRecords && this.dataForm.qualityPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.qualityPhotoRecords.length; i++) {
						if (this.dataForm.qualityPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoFilePath,
								photoPathUri: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.qualityPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let qualityPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoFilePath,
						photoPathUri: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(qualityPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: qualityPhotoDtoList
					};
					this.dataForm.qualityPhotoRecords.push(item);
				}
			}
			this.dialogVisible = false;
		},
		saveMeetPhotoList() {
			if (!this.meetPhotoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.meetPhotoList || this.meetPhotoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}
			let idx = this.meetPhotoListIndex

			if (this.dataForm.meetingDesc[idx].photoRecords == null) {
				this.dataForm.meetingDesc[idx].photoRecords = []
			}
			let item = {
				photoContent: this.meetPhotoContent,
				photoFilePath: this.meetPhotoList[0].photoFilePath,
				photoFilePathUrl: this.meetPhotoList[0].photoFilePathUrl,
			};
			this.dataForm.meetingDesc[idx].photoRecords.push(item);

			this.meetPhotoDialogVisible = false;
		},
		getDescList(descList, subjectNo) {
			if (descList) {
				for (let i = 0; i < descList.length; i++) {
					if (descList[i].subjectNo == subjectNo) {
						return descList[i].reportDescInfos;
					}
				}
			} else {
				return [];
			}
		},
		delMeetDesc(index) {
			this.dataForm.meetingDesc.splice(index, 1);
		},
		addProminentProblemDescItem(subjectNo) {
			let item = {
				weeklyRecNo: this.recNo,
				recNo: '',
				descContent: '',
				dataType: '030202',
				subjectNo: subjectNo,
				originalFlg: '0',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: this.workNo
			};
			if (this.dataForm.prominentProblemDescList) {
				for (let i = 0; i < this.dataForm.prominentProblemDescList.length; i++) {
					if (this.dataForm.prominentProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.prominentProblemDescList[i].reportDescInfos.push(item);
						return
					}
				}
				let group = {
					subjectNo: subjectNo,
					reportDescInfos: []
				}
				group.reportDescInfos.push(item)
				this.dataForm.prominentProblemDescList.push(group)
			} else {
				let group = {
					subjectNo: subjectNo,
					reportDescInfos: []
				}
				group.reportDescInfos.push(item)
				this.dataForm.prominentProblemDescList = []
				this.dataForm.prominentProblemDescList.push(group)
			}
			this.addFlg = true;
		},
		deleteProminentProblemDescItem(subjectNo, index) {
			if (this.dataForm.prominentProblemDescList) {
				for (let i = 0; i < this.dataForm.prominentProblemDescList.length; i++) {
					if (this.dataForm.prominentProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.prominentProblemDescList[i].reportDescInfos.splice(index, 1);
					}
				}
			}
		},
		goBack() {
			this.$router.back()
		},
		getWeekInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportinfo/createWeekData",
				method: "get",
				params: {
					workNo: $common.getItem("workNo"),
					recNo: this.recNo
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body;
					this.dataForm.beginTime = data.body.beginTime;
					this.dataForm.endTime = data.body.endTime;

					this.basicVisible = false;
					this.addFlg = false;
					this.updateFlg = false;
					this.updateDescRecNo = '';
				}
			});
		},
		getWeeklySituationList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/weeklyreportinfo/getWeeklySituationList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.projectDesc = data.body.projectDesc
					this.dataForm.constructionProgress = data.body.constructionProgress
					this.dataForm.stopPointCheckDesc = data.body.stopPointCheckDesc
					this.dataForm.qualityProblemDescList = data.body.qualityProblemDescList
					this.dataForm.patrolCheckDesc = data.body.patrolCheckDesc
					this.dataForm.prominentProblemDescList = data.body.prominentProblemDescList
					this.dataForm.fileCheckRecords = data.body.fileCheckRecords
					this.dataForm.designEditDesc = data.body.designEditDesc
					this.dataForm.hseInfoDesc = data.body.hseInfoDesc
					this.dataForm.otherDesc = data.body.otherDesc
					this.dataForm.meetingDesc = data.body.meetingDesc
				}
			});
		},
		deleteWeeklyReportFile(recNo, dataType) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weeklyreportdescinfo/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getWeeklySituationList()
							}
						})
					}
				});
			})
		},
		uploadImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode == 200) {
					this.dataForm.progressPhotoRecords.push({
						photoFilePath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		delMeetPhoto(index1, index2) {
			this.dataForm.meetingDesc[index1].photoRecords.splice(index2, 1);
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getWeekSubjectList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					this.showSubjectName = false;
					if (this.subjectList != null && this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubjectName = true;
					}
				}
			});
		},
		jump_to_basic() {
			this.menuId = 'basic'
			this.$refs["basic"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_overview() {
			this.menuId = 'overview'
			this.$refs["overview"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_progress() {
			this.menuId = 'progress'
			this.$refs["progress"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_quality() {
			this.menuId = 'quality'
			this.$refs["quality"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_workFile() {
			this.menuId = 'workfile'
			this.$refs["workfile"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_design() {
			this.menuId = 'design'
			this.$refs["design"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_hse() {
			this.menuId = 'hse'
			this.$refs["hse"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_meet() {
			this.menuId = 'meet'
			this.$refs["meet"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_other() {
			this.menuId = 'other'
			this.$refs["other"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_enclosure() {
			this.menuId = 'enclosure'
			this.$refs["enclosure"].scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		},
	},

};
</script>
<style lang="scss" scoped="scoped">
.el-form-item {
	margin-bottom: 5px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.addImgBox200 {
	width: 200px;
	height: 200px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.elCardTitle {
	font-size: 18px;
	font-weight: bold;
	color: #00428e;
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #00428e;
}

.selItemInput.descAreaLg {
	width: 1030px !important;
}

.selItemInput.descAreaLg1 {
	width: 430px !important;
}

.selItemInput.descAreaLg2 {
	width: 230px !important;
}

.time {
	font-size: 13px;
	color: #999;
}

.bottom {
	margin-top: 3px;
	line-height: 12px;
	vertical-align: bottom;
}

.button {
	padding: 0;
	float: right;
}

.image {
	width: 100%;
	height: 200px;
	margin-top: 5px;
	display: block;
}

.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both
}

.itemLabelspan {
	font-weight: bold;
	// color: #606266;
	margin-right: 10px;
	font-size: 13px !important;
}

.itemLabelspanDetail {
	font-weight: bold;
	// color: #606266;
	margin-right: 120px;
	font-size: 13px !important;
}

.itemLabeltext {
	color: #606266;
	margin-right: 10px;
}

.t-column-ellipsis {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	padding-bottom: 10px;
	height: 50px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	font-size: 13px !important;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.border-form .el-row.set_border {
	// border-bottom: solid #dadada 1px;
	// border-left: solid #dadada 1px;
	// border-right: solid #dadada 1px;
	border: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 2px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.col-set_border1 {
	border: solid #dadada 1px;
}

.col-set_border2 {
	border: solid #dadada 1px;
	border-left: solid #dadada 0px;
}

.col-set_border3 {
	border: solid #dadada 1px;
	border-top: solid #dadada 0px;
}

.col-set_border4 {
	border-right: solid #dadada 1px;
	border-bottom: solid #dadada 1px;
}

.set_color::v-deep .el-textarea__inner {
	background-color: #e1f1ff !important;
}

.set_color1::v-deep .el-input__inner {
	background-color: #e1f1ff !important;
	// height:35px !important
}

.btn1 {
	bottom: 13px;
	margin-left: -60px;
	position: fixed;
}

.rebtn1 {
	bottom: 13px;
	position: fixed;
}

.set_bg {
	width: 65%;
	height: 50px;
	bottom: 6px;
	position: fixed;
	left: 20%;
	background-color: #f7f1f1;
}

.set_menu {
	position: fixed;
	cursor: pointer;
	left: 89%;
	font-size: smaller;
	color: #6d6c6c;
}

.set_btn {
	left: 88%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: white;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}

.set_btn_border {
	left: 88%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: #81D3F8;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}

.set_lewi {
	// width: 100px;
	font-weight: bold;
	color: #606266;
	margin-left: -5px;
	// font-weight: bold;
}

.el-icon-edit-outline {
	color: #169BD5;
	font-size: large;
	margin-left: 20px;
	margin-top: 178px;
	margin-right: 2px;
	cursor: pointer
}

::v-deep(.el-form-item__content) {
	flex: 1 !important;
	width: 100% !important;
}

::v-deep(.sp-input) {
	width: 100% !important;
	display: block !important;
	font-size: 13px !important;
}

::v-deep(.sp-input .el-input__inner) {
	width: 100% !important;
	box-sizing: border-box !important;
}

::v-deep(.srt .el-input__inner) {
	width: 119% !important;
}

.el-icon-finished {
	color: #169BD5;
	font-size: large;
	margin-left: 20px;
	margin-top: 178px;
	margin-right: 2px;
	cursor: pointer
}

.el-icon-takeaway-box {
	color: #169BD5;
	font-size: 16px;
	margin-left: 20px;
	// margin-top:179px;
	margin-right: 2px;
	cursor: pointer
}

::v-deep .desc_input1 .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	resize: none;
}

.set_span {
	display: block;
	font-size: 13px !important;
	/* 将span转换为块级元素 */
	max-width: 275px;
	/* 设置固定长度 */
	white-space: nowrap;
	/* 不换行 */
	overflow: hidden;
	/* 超出部分隐藏 */
	text-overflow: ellipsis;
	/* 超出部分显示省略号 */
	cursor: default;
	/* 将鼠标光标设置为默认样式 */
}

::v-deep .desc_input_bc .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	background-color: #e1f1ff;
	resize: none;
}

.set_nonS {
	border-bottom: solid #dadada 1px;
	min-height: 28px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.desc_span {
	padding-top: 2px;
	line-height: 22px;
	border-bottom: solid transparent 1px;
	white-space: pre-line;
	font-size: 13px;
}

.desc_btn {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
	margin-top: -8px;
}

.un_col {
	border: 1px solid transparent;
	text-align: center;
	margin-top: -5px;
}

.desc_zw {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: white;
}

::v-deep .monthly-input .el-input__inner {
	height: 26px !important;
	line-height: 26px !important;
	padding: 0 8px !important;
	/* 留一点内边距，文字不贴边 */
	border: 1px solid #DCDFE6 !important;
	/* 强制显示边框 */
	border-radius: 4px !important;
	box-sizing: border-box !important;
}
</style>
